var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _g2, _g3, _path16, _path17, _path18, _path19, _g4, _g5, _path20, _path21, _path22, _path23, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComponentsGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 593,
    height: 593,
    viewBox: "0 0 593 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_15)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.5 593C460.252 593 593 460.252 593 296.5C593 132.748 460.252 0 296.5 0C132.748 0 0 132.748 0 296.5C0 460.252 132.748 593 296.5 593Z",
    fill: "#9337FD",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M296.5 554.976C439.252 554.976 554.976 439.252 554.976 296.5C554.976 153.748 439.252 38.024 296.5 38.024C153.748 38.024 38.024 153.748 38.024 296.5C38.024 439.252 153.748 554.976 296.5 554.976Z",
    fill: "#9337FD",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M293.784 508.803C411.036 508.803 506.087 413.752 506.087 296.5C506.087 179.248 411.036 84.197 293.784 84.197C176.532 84.197 81.481 179.248 81.481 296.5C81.481 413.752 176.532 508.803 293.784 508.803Z",
    fill: "#9337FD",
    fillOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M427.322 104.115H178.352C176.352 104.115 174.731 105.736 174.731 107.736V455.389C174.731 457.389 176.352 459.01 178.352 459.01H427.322C429.322 459.01 430.943 457.389 430.943 455.389V107.736C430.943 105.736 429.322 104.115 427.322 104.115Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M404.189 194H201.811C200.811 194 200 194.811 200 195.811V228.189C200 229.189 200.811 230 201.811 230H404.189C405.189 230 406 229.189 406 228.189V195.811C406 194.811 405.189 194 404.189 194Z",
    fill: "#F3F3F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M404.189 245H201.811C200.811 245 200 245.811 200 246.811V279.189C200 280.189 200.811 281 201.811 281H404.189C405.189 281 406 280.189 406 279.189V246.811C406 245.811 405.189 245 404.189 245Z",
    fill: "#F3F3F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M404.189 143H201.811C200.811 143 200 143.811 200 144.811V177.189C200 178.189 200.811 179 201.811 179H404.189C405.189 179 406 178.189 406 177.189V144.811C406 143.811 405.189 143 404.189 143Z",
    fill: "#F3F3F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M404.189 347H201.811C200.811 347 200 347.811 200 348.811V381.189C200 382.189 200.811 383 201.811 383H404.189C405.189 383 406 382.189 406 381.189V348.811C406 347.811 405.189 347 404.189 347Z",
    fill: "#F3F3F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M404.189 398H201.811C200.811 398 200 398.811 200 399.811V432.189C200 433.189 200.811 434 201.811 434H404.189C405.189 434 406 433.189 406 432.189V399.811C406 398.811 405.189 398 404.189 398Z",
    fill: "#F3F3F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M404.189 296H201.811C200.811 296 200 296.811 200 297.811V330.189C200 331.189 200.811 332 201.811 332H404.189C405.189 332 406 331.189 406 330.189V297.811C406 296.811 405.189 296 404.189 296Z",
    fill: "#F3F3F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.699 240.35H198.811C197.811 240.35 197 241.161 197 242.161V253.93C197 254.93 197.811 255.741 198.811 255.741H247.699C248.699 255.741 249.51 254.93 249.51 253.93V242.161C249.51 241.161 248.699 240.35 247.699 240.35Z",
    fill: "#FCEFFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.106 307H222.68C221.2 307 220 308.2 220 309.68V373.32C220 374.8 221.2 376 222.68 376H449.106C450.586 376 451.786 374.8 451.786 373.32V309.68C451.786 308.2 450.586 307 449.106 307Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M272.253 320.398H232.729C231.249 320.398 230.049 321.598 230.049 323.078V360.592C230.049 362.072 231.249 363.272 232.729 363.272H272.253C273.733 363.272 274.932 362.072 274.932 360.592V323.078C274.932 321.598 273.733 320.398 272.253 320.398Z",
    fill: "#66C085"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M435.039 320.398H284.981C284.241 320.398 283.641 320.998 283.641 321.738V330.447C283.641 331.186 284.241 331.786 284.981 331.786H435.039C435.779 331.786 436.379 331.186 436.379 330.447V321.738C436.379 320.998 435.779 320.398 435.039 320.398Z",
    fill: "#66C085",
    fillOpacity: 0.11
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M321.156 339.155H284.981C284.241 339.155 283.641 339.755 283.641 340.495V349.204C283.641 349.943 284.241 350.543 284.981 350.543H321.156C321.896 350.543 322.495 349.943 322.495 349.204V340.495C322.495 339.755 321.896 339.155 321.156 339.155Z",
    fill: "#66C085",
    fillOpacity: 0.11
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 244,
    y: 333,
    width: 17,
    height: 17
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M260.195 333.796H244.117V349.874H260.195V333.796Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.184 336.476H246.126C245.386 336.476 244.786 337.076 244.786 337.816V345.854C244.786 346.594 245.386 347.194 246.126 347.194H258.184C258.924 347.194 259.524 346.594 259.524 345.854V337.816C259.524 337.076 258.924 336.476 258.184 336.476Z",
    stroke: "white",
    strokeWidth: 1.33981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.786 340.495H259.524",
    stroke: "white",
    strokeWidth: 1.33981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.109 238.105H85.1023C83.1022 238.105 81.4809 239.726 81.4809 241.726V327.734C81.4809 329.734 83.1022 331.355 85.1023 331.355H391.109C393.109 331.355 394.73 329.734 394.73 327.734V241.726C394.73 239.726 393.109 238.105 391.109 238.105Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.098 256.212H98.6824C96.6824 256.212 95.061 257.833 95.061 259.833V310.533C95.061 312.533 96.6824 314.154 98.6824 314.154H152.098C154.098 314.154 155.719 312.533 155.719 310.533V259.833C155.719 257.833 154.098 256.212 152.098 256.212Z",
    fill: "#CA212F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M372.096 256.212H169.3C168.3 256.212 167.489 257.023 167.489 258.023V269.792C167.489 270.792 168.3 271.603 169.3 271.603H372.096C373.096 271.603 373.907 270.792 373.907 269.792V258.023C373.907 257.023 373.096 256.212 372.096 256.212Z",
    fill: "#FCEFFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M218.188 281.562H169.3C168.3 281.562 167.489 282.373 167.489 283.373V295.142C167.489 296.142 168.3 296.953 169.3 296.953H218.188C219.188 296.953 219.999 296.142 219.999 295.142V283.373C219.999 282.373 219.188 281.562 218.188 281.562Z",
    fill: "#FCEFFA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 274,
    width: 22,
    height: 23
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.801 274.319H114.073V296.047H135.801V274.319Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.086 277.94H116.789C115.789 277.94 114.979 278.751 114.979 279.751V290.615C114.979 291.615 115.789 292.426 116.789 292.426H133.086C134.086 292.426 134.896 291.615 134.896 290.615V279.751C134.896 278.751 134.086 277.94 133.086 277.94Z",
    stroke: "white",
    strokeWidth: 1.81069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.979 283.373H134.896",
    stroke: "white",
    strokeWidth: 1.81069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.109 238.105H85.1023C83.1022 238.105 81.4809 239.726 81.4809 241.726V327.734C81.4809 329.734 83.1022 331.355 85.1023 331.355H391.109C393.109 331.355 394.73 329.734 394.73 327.734V241.726C394.73 239.726 393.109 238.105 391.109 238.105Z",
    fill: "white"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M152.098 256.212H98.6824C96.6824 256.212 95.061 257.833 95.061 259.833V310.533C95.061 312.533 96.6824 314.154 98.6824 314.154H152.098C154.098 314.154 155.719 312.533 155.719 310.533V259.833C155.719 257.833 154.098 256.212 152.098 256.212Z",
    fill: "#CA212F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M372.096 256.212H169.3C168.3 256.212 167.489 257.023 167.489 258.023V269.792C167.489 270.792 168.3 271.603 169.3 271.603H372.096C373.096 271.603 373.907 270.792 373.907 269.792V258.023C373.907 257.023 373.096 256.212 372.096 256.212Z",
    fill: "#FCEFFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M218.188 281.562H169.3C168.3 281.562 167.489 282.373 167.489 283.373V295.142C167.489 296.142 168.3 296.953 169.3 296.953H218.188C219.188 296.953 219.999 296.142 219.999 295.142V283.373C219.999 282.373 219.188 281.562 218.188 281.562Z",
    fill: "#FCEFFA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 274,
    width: 22,
    height: 23
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M135.801 274.319H114.073V296.047H135.801V274.319Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.086 277.94H116.789C115.789 277.94 114.979 278.751 114.979 279.751V290.615C114.979 291.615 115.789 292.426 116.789 292.426H133.086C134.086 292.426 134.896 291.615 134.896 290.615V279.751C134.896 278.751 134.086 277.94 133.086 277.94Z",
    stroke: "white",
    strokeWidth: 1.81069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.979 283.373H134.896",
    stroke: "white",
    strokeWidth: 1.81069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_15",
    x: 193.204,
    y: 282.883,
    width: 285.378,
    height: 122.592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.67961
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.3981
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_15"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_15",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2_15",
    x: 45.2671,
    y: 205.513,
    width: 385.677,
    height: 165.678,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.62137
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_15"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_15",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2_15",
    x: 45.2671,
    y: 205.513,
    width: 385.677,
    height: 165.678,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.62137
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_15"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_15",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 593,
    height: 593,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentsGroup);
export default __webpack_public_path__ + "static/media/componentsGroup.bd80a0bc4f10f37a9e81a8aab1e329d1.svg";
export { ForwardRef as ReactComponent };